import classNames from 'classnames'

import { useDateLocale, useTimeZone } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import Text from '../../Text'

import { QA_NAME_VIEWING_DATE_TILE } from './RentalPortalViewingDateTile.constants'
import {
  getIsViewingDatePast,
  getViewingDateTileLabels,
} from './RentalPortalViewingDateTile.utils'

import * as styles from './RentalPortalViewingDateTile.module.css'

function RentalPortalViewingDateTile({ isFreeSlot, start }) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { dayLabel, monthLabel } = getViewingDateTileLabels({
    locale,
    start,
    timezone,
  })

  const tileClassName = classNames(styles.RentalPortalViewingDateTile, {
    [styles.freeSlot]: isFreeSlot,
    [styles.past]: getIsViewingDatePast({ start, timezone }),
  })

  return start ? (
    <div
      {...getQaSelector({ value: QA_NAME_VIEWING_DATE_TILE })}
      className={tileClassName}
    >
      <Text className={styles.month}>{monthLabel}</Text>
      <Text className={styles.day}>{dayLabel}</Text>
    </div>
  ) : null
}

export default RentalPortalViewingDateTile
